import React from 'react';
import { config } from 'config';
import { useLocalstorage } from 'hooks';
import { useTranslation } from 'react-i18next';
import {
    HealthSurveys,
    PatientsAttended,
    PsychosocialRisk,
    Quizzes,
    RiskFactors
} from './components';
const {
    campaigns,
    extendedPatientHistory
} = config;

const HEALTH_SURVEYS = 'health_surveys';
const RISK_FACTORS = 'risk_factors';
const PATIENTS_ATTENDED = 'patients_attended';
const PSYCHOSOCIAL_RISK = 'psychosocial_risk';
const QUIZZES = 'quizzes';

const StatisticsAbsenteesm = () => {

    const { t } = useTranslation();

    const [selectedTab, setSelectedTab] = useLocalstorage('statistics-patients-tab', {
        defaultValue: !extendedPatientHistory ? PATIENTS_ATTENDED : RISK_FACTORS
    });

    const tabController = {
        selectedTab,
        setSelectedTab,
        tabs: [{
            hidden: !campaigns,
            label: t('Cuestionarios de salud'),
            value: HEALTH_SURVEYS
        }, {
            hidden: !campaigns,
            label: t('Encuestas'),
            value: QUIZZES
        }, {
            hidden: !extendedPatientHistory,
            label: t('Factores de riesgo'),
            value: RISK_FACTORS
        }, {
            label: t('Pacientes atendidos'),
            value: PATIENTS_ATTENDED
        }, {
            hidden: !campaigns,
            label: t('Riesgo psicosocial'),
            value: PSYCHOSOCIAL_RISK
        }].filter(({ hidden }) => !hidden)
    };

    switch (selectedTab) {
    case (HEALTH_SURVEYS): return <HealthSurveys tabController={ tabController } />;
    case (RISK_FACTORS): return <RiskFactors tabController={ tabController } />;
    case (PATIENTS_ATTENDED): return <PatientsAttended tabController={ tabController } />;
    case (PSYCHOSOCIAL_RISK): return <PsychosocialRisk tabController={ tabController } />;
    case (QUIZZES): return <Quizzes tabController={ tabController } />;
    default: return <PatientsAttended tabController={ tabController } />;
    }
};

StatisticsAbsenteesm.propTypes = {

};

export default StatisticsAbsenteesm;
